import actionCreatorFactory from 'typescript-fsa';
import { ResultType } from '../../type/api.type';

const ActionCreator = actionCreatorFactory('system');

export const SystemActions = {
  pressKey: ActionCreator<string>('press/key'),
  isLoading: ActionCreator<boolean>('is/loading'),
  isMapLoading: ActionCreator<boolean>('is/map/loading'),
  setIsLoading: ActionCreator<boolean>('set/is/loading'),
  setIsLoadingCount: ActionCreator<number>('set/is/loading/count'),
  setIsMapLoading: ActionCreator<boolean>('set/is/map/loading'),
  setIsMapLoadingCount: ActionCreator<number>('set/is/map/loading/count'),
  authError: ActionCreator<any>('auth/error'),
  allReset: ActionCreator('all/reset'),
  resetState: ActionCreator('reset/state'),
  errorHandle: ActionCreator<{ result: ResultType, title: string; }>('error/handle'),
  connectionError: ActionCreator<{message?: string[]}>('connection/error'),
};
